import { render, staticRenderFns } from "./TheFreeSignIcon.vue?vue&type=template&id=9606c44e&"
import script from "./TheFreeSignIcon.vue?vue&type=script&lang=js&"
export * from "./TheFreeSignIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports